<template>
  <v-dialog v-model="dialog" persistent width="500">
    <v-card>
      <v-card-title class="justify-center">Recordatorio</v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" class="text-center">
            <span>
              Has generado una nueva venta de tarjetas de regalo,
              <b
                >no olvides activar las tarjetas correspondientes antes de
                entregar al cliente.</b
              >
            </span>
          </v-col>
          <v-col cols="12">
            <v-row dense>
              <v-spacer></v-spacer>
              <v-col cols="6" md="3" lg="3">
                <v-btn small color="secondary" outlined @click="close()">{{
                  $t("Cancelar")
                }}</v-btn>
              </v-col>
              <v-col cols="6" md="3" lg="3">
                <v-btn small color="primary" @click="goToActivateCards()">{{ $t("Ir a Activar") }}</v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    renderItem(dialog) {
      this.dialog = dialog;
    },
    close() {
      this.dialog = false;
    },
    goToActivateCards() {
      this.$router.push("/pos/gift-card");
    },
  },
};
</script>